import { Typography } from '@mui/material'
import type { HTMLAttributes } from 'react'
import { sumMenuItemStyle } from 'src/features/globalNavigation/components/subMenuItem/subMenuItemStyle'

type Props = {
  title: string
  icon?: React.ReactNode
} & HTMLAttributes<HTMLElement>

/**
 * グローバルナビゲーションのサブメニュー内の個々のアイテム (ただのクリック可能な要素)
 */
export const SubMenuItemClickable = (props: Props) => {
  const { title, icon, ...restProps } = props

  return (
    // biome-ignore lint/a11y/useFocusableInteractive: ただのクリック可能な要素
    // biome-ignore lint/a11y/useSemanticElements: div に role="button" を付与しているため
    <div
      {...restProps}
      css={sumMenuItemStyle.container}
      role="button"
      aria-label={title}
    >
      {icon}
      <Typography variant="subtitle2" css={sumMenuItemStyle.title}>
        {title}
      </Typography>
    </div>
  )
}
